module.exports = __webpack_public_path__ + "img/logo1.88db3d95.png";